export default {
    getRuns:      { method: 'get',  url: 'grid-generation-runs' },
    getRun:       { method: 'get',  url: 'grid-generation-runs/{id}' },
    getRunErrors: { method: 'get',  url: 'grid-generation-runs/{id}/errors' },
    startRun:     { method: 'post', url: 'grid-generation-runs' },
    cancelRun:    { method: 'post', url: 'grid-generation-runs/{id}/cancel' },
}
